// extracted by mini-css-extract-plugin
module.exports = {"sectorDetailsGridRight":"SectorsGridDetailsRight_sectorDetailsGridRight__1m_dM","title":"SectorsGridDetailsRight_title__3d0C1","subTitle":"SectorsGridDetailsRight_subTitle__3O40u"};